import React, { JSX } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import produce from "immer";
import { Assessment, Diagnosis } from "../../../interfaces/AssessmentInterfaces";

interface DiagnosisListProps {
  setAssessment: (value: Partial<Assessment>) => void;
  assessment: Assessment;
}

const DiagnosisList = ({ setAssessment, assessment }: DiagnosisListProps): JSX.Element => {
  const diagnoses = assessment.diagnosis;

  const handleChange = (updated: Diagnosis, value: string) => {
    setAssessment(
      produce(assessment, (draft) => {
        draft.diagnosis = diagnoses.map((d) => (d === updated ? { ...d, diagnosis: value } : d));
      })
    );
  };

  const handleRemove = (target: Diagnosis) => {
    setAssessment(
      produce(assessment, (draft) => {
        draft.diagnosis = diagnoses.filter((d) => d !== target);
      })
    );
  };

  return (
    <>
      {diagnoses.map((item, index) => (
        <Box
          key={item.icdCode ?? `diagnosis-${index}`}
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2 }}
        >
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={item.diagnosis}
            onChange={(e) => handleChange(item, e.target.value)}
          />
          <IconButton size="small" onClick={() => handleRemove(item)}>
            <HighlightOffIcon />
          </IconButton>
        </Box>
      ))}
    </>
  );
};

export default DiagnosisList;
